import axios from "../axios";

export async function fetchDeviationNotificationSettings() {
  return axios
    .get("/quality/deviations/settings")
    .then((response) => response.data?.data || response.data);
}

export async function updateDeviationNotificationSettings(payload) {
  return axios
    .put("/quality/deviations/settings", {
      deviation_notification_settings: payload,
    })
    .then((response) => response.data?.data || response.data);
}
